import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import '../Chatbot.scss'

const PendingResponseBubble = () => {
  return (
    <div className="pending-response-container">
      <div className="pending-bubble">
        <Element className="typing-indicator" style={{ fontSize: 14 }}>
          <span className="text">
            <Translate value="chatbot.THINKING" />
            <span className="loading-dots"></span>
          </span>
        </Element>
      </div>
    </div>
  )
}

export default PendingResponseBubble
